import { OrganizationType } from "../types/organization.type";
import { orgScopedPermission } from "./jwt";
import type { LegacyRole } from "./types";

export interface EsgNavItem {
  text: string;
  path: string;
  allowedTypes: OrganizationType[];
  entity: string;
  action: string;
  legacyRoles?: readonly LegacyRole[];
  /** When true, keep the item in the catalog but hide it from the sidebar. */
  hidden?: boolean;
}

const ALL_ORG_TYPES = [
  OrganizationType.WASTE_OUTLET,
  OrganizationType.TRUCK,
  OrganizationType.RECYCLER,
];

/** ESG sidebar catalog — permission + org-type gating. */
export const ESG_NAV_CATALOG: EsgNavItem[] = [
  {
    text: "Dashboard",
    path: "/",
    allowedTypes: ALL_ORG_TYPES,
    entity: "dashboard",
    action: "read",
  },
  {
    text: "ESG Reports",
    path: "/esg-reports",
    allowedTypes: ALL_ORG_TYPES,
    entity: "esg_report",
    action: "read",
  },
  {
    text: "Waste Management",
    path: "/waste-management",
    allowedTypes: ALL_ORG_TYPES,
    entity: "report",
    action: "read",
    hidden: true,
  },
  {
    text: "Data Source",
    path: "/data-entry",
    allowedTypes: ALL_ORG_TYPES,
    entity: "forms_submission",
    action: "read",
  },
  {
    text: "Employee training",
    path: "/employee-training",
    allowedTypes: ALL_ORG_TYPES,
    entity: "training_record",
    action: "read",
  },
  {
    text: "Health & Safety",
    path: "/hse",
    allowedTypes: ALL_ORG_TYPES,
    entity: "forms_submission",
    action: "read",
  },
];

export function resolveEsgNavPermission(
  entity: string,
  action: string,
  orgId: string | null,
): string | null {
  if (!orgId) {
    return null;
  }
  return orgScopedPermission(orgId, entity, action);
}

export const PERM_DASHBOARD_READ = (orgId: string) =>
  orgScopedPermission(orgId, "dashboard", "read");
export const PERM_ESG_REPORT_READ = (orgId: string) =>
  orgScopedPermission(orgId, "esg_report", "read");
export const PERM_REPORT_READ = (orgId: string) =>
  orgScopedPermission(orgId, "report", "read");
export const PERM_FORMS_READ = (orgId: string) =>
  orgScopedPermission(orgId, "forms_submission", "read");
export const PERM_FORMS_WRITE = (orgId: string) =>
  orgScopedPermission(orgId, "forms_submission", "create");
export const PERM_TRAINING_READ = (orgId: string) =>
  orgScopedPermission(orgId, "training_record", "read");
export const PERM_TRAINING_WRITE = (orgId: string) =>
  orgScopedPermission(orgId, "training_program", "manage");
export const PERM_USER_LIST = (orgId: string) =>
  orgScopedPermission(orgId, "user", "list");
export const PERM_USER_WRITE = (orgId: string) =>
  orgScopedPermission(orgId, "user", "write");
